import { ISignCommand } from '@/sign/commands/isign.command';
import { SigningParamsContainer } from '@/sign/models/signing-params.model';
import { ISignStrategyFactory } from '../factories/isign-strategy.factory';
import { PrivateKeyType, SignMethod } from '../models/sign-constants';
import { ISignStrategy } from '@/sign/strategies/isign.strategy';

export class SignCommand implements ISignCommand {
  private strategyFactory: ISignStrategyFactory;
  private signStrategyParams: any;
  constructor(strategyFactory: ISignStrategyFactory, signStrategyParams: any) {
    if (!strategyFactory) throw new Error('Factory is not defined');
    if (!signStrategyParams) throw new Error('Strategy signing params are not defined');
    this.strategyFactory = strategyFactory;
    this.signStrategyParams = signStrategyParams;
  }

  public async execute(signMethodParams: SigningParamsContainer): Promise<any> {
    if (!signMethodParams) throw new Error('Method signing params are not defined');
    if (PrivateKeyType.Seal in signMethodParams) throw new Error('Seal is not supported');

    let signingParams = signMethodParams[PrivateKeyType.Key];
    if (!signingParams) throw new Error('Key signing params are not defined');

    let signStrategy: ISignStrategy;
    switch (signingParams.signMethod) {
      case SignMethod.FileSystem:
        signStrategy = this.strategyFactory.createSignFileSystemStrategy(this.signStrategyParams);
        break;
      case SignMethod.Device:
        signStrategy = this.strategyFactory.createSignDeviceStrategy(this.signStrategyParams);
        break;
      case SignMethod.Cloud:
        signStrategy = this.strategyFactory.createSignCloudStrategy(signingParams.signProvider, signingParams.keyReaderType, this.signStrategyParams);
        break;
      default:
        throw new Error('Sign method is not supported');
    }

    if (!signStrategy) {
      throw new Error('Sign strategy is not defined');
    }

    return signStrategy.execute(signingParams);
  }
}
